export default __webpack_public_path__ + "static/media/jobseeker.83b59aef.png";